module.exports = __webpack_public_path__ + "static/media/corona.35c2d956.png";